import Vue from 'vue'
import Router from 'vue-router'

// 页面资源
// TODO 做成响应式 合并pc与mobile组件之间重复的代码
import Home from '@/views/Home/Home.vue'

import TutorialDetail from '@/views/TutorialDetail/TutorialDetail.vue'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home
    },
    {
      path: '/tutorialDetail',
      name: 'tutorialDetail',
      component: TutorialDetail
    },
   
    {
      path: '*',
      redirect: '/'
    },
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router